// extracted by mini-css-extract-plugin
export var container = "_78-0";
export var containerTopRight = "_78-1";